import React from 'react';
import { Link } from 'react-router-dom';

import openInNewIcon from '../../../assets/img/open-in-new-black.svg';

const Widget = ({
  id,
  w,
  showFlowEfficiency,
  title,
  customizeMode,
  children,
  linkTo,
  className = '',
  style,
}) => {
  return (
    <div className="grid-stack-item" id={id} style={style}>
      <div className={`cell ${className}`}>
        <div className='cell-header'>
          <h4>
            {title}
            {/* a card that opens its chart says so, with the same icon as the Process Improvement cards */}
            {linkTo && !customizeMode && <img className='cell-link-icon' src={openInNewIcon} alt='' />}
          </h4>
          {customizeMode && (
            <div className='card-drag'>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M12 2v20" />
                <path d="m15 19-3 3-3-3" />
                <path d="m19 9 3 3-3 3" />
                <path d="M2 12h20" />
                <path d="m5 9-3 3 3 3" />
                <path d="m9 5 3-3 3 3" />
              </svg>
            </div>
          )}
        </div>
        {children}
        {linkTo && !customizeMode && <Link className='link' to={linkTo}></Link>}
      </div>
    </div>
  );
};

export default Widget;
